import React from "react";
import CustomButton from "./CustomButton";
import { isMobile } from "react-device-detect";

interface ICustomStepperProps {
  steps: string[];
  activeStep: number;
  handleNext?: any;
  handleBack?: () => void;
  renderStepContent?: () => React.ReactNode;
  className?: string;
  nextBtnDisable?: boolean;
  continueButtonLabel?: string;
  showBackButton?: boolean;
  disableButtons?: boolean;
  disableSteps?: boolean;
  hideNextButton?: boolean;
  children?: any;
}
const CustomStepper: React.FC<ICustomStepperProps> = ({
  steps,
  activeStep,
  handleNext,
  handleBack,
  renderStepContent,
  nextBtnDisable,
  continueButtonLabel = "continue",
  showBackButton = false,
  disableButtons = false,
  hideNextButton = false,
  disableSteps = false,
  children,
}: ICustomStepperProps) => {
  const getLabelStyle = (index: number) => {
    if (isMobile) {
      return `step-label ${index == activeStep ? "step-label-active" : ""}`;
    }
    return index <= activeStep ? "step-label step-label-active" : "step-label";
  };

  const getStepStyle = (index: number) => {
    if (isMobile) {
      if (
        index === activeStep ||
        (activeStep === -1 && index === steps.length - 1)
      ) {
        return "step step-active";
      }
      return "step";
    }
    return index <= activeStep ? "step step-active" : "step";
  };

  return (
    <>
      <div className="container">
        {!disableSteps && (
          <div className={"step-container"}>
            {steps.map((label: any, index: number) => {
              return (
                <div key={index} className={getStepStyle(index)}>
                  <span className={getLabelStyle(index)}>{label}</span>
                </div>
              );
            })}
          </div>
        )}
        {children}
        {renderStepContent && renderStepContent()}
      </div>
      {!disableButtons && (
        <div
          className={`btn-container ${
            (!showBackButton || hideNextButton) && " single"
          }`}
        >
          {showBackButton && (
            <CustomButton
              variant="outlined"
              disableElevation={false}
              label={"back"}
              onClick={handleBack}
              buttonSize="stepper-button-size"
            />
          )}
          {!hideNextButton && (
            <CustomButton
              variant="contained"
              disableElevation={true}
              label={
                activeStep === steps.length - 1 ? continueButtonLabel : "next"
              }
              onClick={handleNext}
              type="submit"
              disabled={nextBtnDisable}
              buttonSize="stepper-button-size"
            />
          )}
        </div>
      )}
    </>
  );
};

export default CustomStepper;
